import { LowInfoContact } from './low-info-contact';
import { ContactFonction } from './contact-fonction';
import { ContactLiensMembresRelations } from './contact-liens-membres-relations';
import { ContactMemberLinkDto, LinkedMembersInfosDTO } from 'src/app/shared/interfaces';
import { SelectItem } from 'primeng/api';

export class ContactsLienMembres {
  public id: number;
  public name: string;
  public contactsLiensMembresRelations: ContactLiensMembresRelations;
  public premierContact: LowInfoContact;
  public secondContact: LowInfoContact;
  public telephone?: string;
  public flagDelete?: number;
  public __CREATED_BY_USERID?: number;
  public __CREATED_ON?: string; // ($date - time)
  public __MODIFIED_BY_USERID?: number;
  public __MODIFIED_ON?: string; // ($date - time)
  public __DELETED_BY_USERID?: number;
  public __DELETED_ON?: string; // ($date - time)
  public fonction: ContactFonction;
  public email?: string;
  public fax?: string;

  // Fields for super table
  public linkSociety: string;
  public tva: string;
  public formeJuridique: string;
  public adresse: string;
  codePostal: string;
  gsm: string;
  localite: string;
  mail: string;
  relationId: number;
  site: string;
  titre: string;

  constructor(data?: ContactMemberLinkDto) {
    Object.assign(this, data);
    if (this.secondContact && this.secondContact.nom) {
      this.linkSociety = this.secondContact.nom;
    }
  }
}

export class LinkedMembersInfos {
  //basic LienMembresInfosDTO
  id: number;
  simpleSociete: boolean;
  lienContactId: number;
  lienContact: {
    id: number;
    nom: string;
    prenom: string;
  };
  lienInfo: {
    titre: string;
    relationId: number;
    adresse: string;
    codePostal: string;
    localite: string;
    telephone: string;
    fax: string;
    gsm: string;
    site: string;
    mail: string;
    nePasUtiliser: boolean;
  };
  //Added infos on New model
  titre: string;
  adresse: string;
  cp: string;
  localite: string;
  fax: string;
  gsm: string;
  mail: string;
  site: string;
  telephone: string;
  name: string;
  relation: string;

  constructor(data: LinkedMembersInfosDTO, listOfRelationLinks?: SelectItem<unknown>[]) {
    Object.assign(this, data);
    this.titre = this.lienInfo.titre;
    this.adresse = this.lienInfo.adresse;
    this.cp = this.lienInfo.codePostal;
    this.localite = this.lienInfo.localite;
    this.fax = this.lienInfo.fax;
    this.gsm = this.lienInfo.gsm;
    this.mail = this.lienInfo.mail;
    this.site = this.lienInfo.site;
    this.telephone = this.lienInfo.telephone;
    this.name = (this.lienContact.nom ? this.lienContact.nom + ' ' : '') + (this.lienContact.prenom ? this.lienContact.prenom : '');

    if (this.lienInfo.relationId && listOfRelationLinks) {
      this.relation = listOfRelationLinks.find((relation) => relation.value === this.lienInfo.relationId)?.label;
    }
  }
}

export class LinkedMembersParams {
  titre: string;
  relationId: number;
  adresse: string;
  codePostal: string;
  localite: string;
  telephone: string;
  fax: string;
  gsm: string;
  site: string;
  mail: string;
  nePasUtiliser: boolean;
}

export class LinkedMembersTable {
  linkId: number;
  nameContact1: string;
  nameContact2: string;
  contactsLiensMembresRelations: { label: string; value: number } | null;
  fonction: string;

  secondContactId: number;
  contactAsFirst?: boolean;
}
